// extracted by mini-css-extract-plugin
export default {"overlay":"ww-z","bodyOpen":"xw-z","content":"yw-z","header":"zw-z","close":"Aw-z","closeNoHeading":"Bw-z"};